module.exports = __webpack_public_path__ + "static/media/Lauen_Chil_work.2cd35506.svg";